import { buildCreateApi, coreModule, reactHooksModule } from '@reduxjs/toolkit/query/react';

import { baseQuery } from './baseQuery';
import { ApiTags } from './apiTags';

const createApi = buildCreateApi(coreModule(), reactHooksModule());

export const api = createApi({
    reducerPath: 'api',
    baseQuery,
    tagTypes: Object.values(ApiTags),
    endpoints: () => ({}),
});
